const pageNameKey = "userManagementPage";

export const userManagementPageEn = {
  [pageNameKey]: {
    errorLoadingRolesText: "Error loading roles descriptions.",
  },
};

export const userManagementPagePtBr = {
  [pageNameKey]: {
    errorLoadingRolesText: "Erro ao carregar as descrições das funções.",
  },
};

export const userManagementPageDe = {
  [pageNameKey]: {
    errorLoadingRolesText: "Fehler beim Laden der Rollenbeschreibungen.",
  },
};

export const userManagementPageZhHans = {
  [pageNameKey]: {
    errorLoadingRolesText: "加载角色描述时出错。",
  },
};

export const userManagementPageIt = {
  [pageNameKey]: {
    errorLoadingRolesText:
      "Errore durante il caricamento delle descrizioni dei ruoli.",
  },
};

export const userManagementPageEs = {
  [pageNameKey]: {
    errorLoadingRolesText: "Error al cargar las descripciones de los roles.",
  },
};

export const userManagementPageNl = {
  [pageNameKey]: {
    errorLoadingRolesText: "Fout bij het laden van rolbeschrijvingen.",
  },
};

export const userManagementPageTr = {
  [pageNameKey]: {
    errorLoadingRolesText: "Rollerin açıklamaları yüklenirken hata oluştu.",
  },
};
